module.exports = __webpack_public_path__ + "img/nexus-logo.8a3ab158.png";